import { render, staticRenderFns } from "./extrato.vue?vue&type=template&id=83cb90d2&"
import script from "./extrato.vue?vue&type=script&lang=js&"
export * from "./extrato.vue?vue&type=script&lang=js&"
import style0 from "./extrato.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports